import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import GrayFade from '../GrayFade/GrayFade';
import {usePromiseTracker} from 'react-promise-tracker';
import {promiseAreas} from '../../../util/uiconstants';

export function Fetch(props) {
	const {fetch, children, loader, area = undefined, useGrayFade, className} = props;

	const [data, setData] = useState();

	const [isLoading, setIsLoading] = useState(true);

	const {promiseInProgress} = usePromiseTracker({area: area});

	useEffect(() => {
		let promise = fetch && fetch();
		if (promise instanceof Promise) {
			promise = promise.finally(() => {
				setIsLoading(false);
			});
		} else {
			setData(promise);
			setIsLoading(false);
		}

		return () => {
			setIsLoading(true);
		};
	}, [fetch]);

	useEffect(() => {
		if (typeof area === 'string' && promiseAreas.hasOwnProperty(area)) {
			setIsLoading(promiseInProgress);
		}
	}, [promiseInProgress]);

	const loaderRender = <>{loader ? loader : <LoadingIndicator view={'inlineView'} show={isLoading} />}</>;
	const fetchRenderContent = React.Children.map(children, (child) =>
		React.cloneElement(child, {isLoading, setIsLoading, data})
	);

	return (
		<React.Fragment>
			{useGrayFade ? (
				<GrayFade isGrayFade={isLoading} className={className}>
					<>{fetchRenderContent}</>
				</GrayFade>
			) : (
				<React.Fragment>
					{isLoading ? (
						<StyledFetchLoader className="StyledFetchLoader fetch-loader">{loaderRender}</StyledFetchLoader>
					) : (
						<React.Fragment>{fetchRenderContent}</React.Fragment>
					)}
				</React.Fragment>
			)}
		</React.Fragment>
	);
}

Fetch.propTypes = {
	fetch: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool,
	loader: PropTypes.node
};

Fetch.defaultProps = {
	fullScreen: false
};

export default Fetch;

const StyledFetchLoader = styled.section`
	display: flex;
	align-items: center;
	height: inherit;
	min-height: inherit;
	justify-content: center;
`;
